export const saveFiltersInLocalStorage = (localStorageKeyToSet, filtersObject) => {
  const stringifiedFilters = JSON.stringify(filtersObject);
  const encodedFilters = encodeURI(stringifiedFilters);
  localStorage.setItem(localStorageKeyToSet, encodedFilters);
};

export const getSavedFiltersFromLocalStorage = (localStorageKeyToGet) => {
  const savedFilters = localStorage.getItem(localStorageKeyToGet);
  if (!savedFilters) return {};
  const decodedFilters = decodeURI(savedFilters);
  return JSON.parse(decodedFilters);
};
